import React, { useEffect, useState, useRef } from 'react';
import Axios from 'axios';
import {
	getCurrencySymbol,
	loadStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import styled from 'styled-components';
import { LoaderGif } from '../../../../FlyfishComponents/flyfishIcons/icons';
const CartContainer = styled.div`
background-color:#fff;
margin-top: 20px;
>div{
	display: flex;
    justify-content: flex-start;
    align-items: flex-start;
	margin-bottom: 10px;
	>img{
		aspect-ratio: 4/5;
		height: 150px;
		border:1px solid #00000033;
	}
	>div{
		&:nth-of-type(1){
			margin-left: 15px;
			margin-top: 20px;
			color: #6a6a6a;
		}
	}
}
`
type Props = {
	tenantId;
	cartId?;
	token;
	getTotalItem;

};

const MonacoCartItem = ({
	 cartId,
	 tenantId,
	 token,
	 getTotalItem
}: // botId,
Props) => {

	const[products,setProducts]=useState([])
	const[response,setResponse]=useState<any>({})

	const[once,setOnce]=useState(false)
	useEffect(() => {
		if(once == false){
			setOnce(true)
		   Axios.get(window['BASE_URL'] + `/shop/${tenantId}/cart?cartId=${cartId}`,
		{
			headers: {
				'x-tenant-id': tenantId,
				Authorization: `Bearer ${token}`,
			},
		}
		
		
		).then(
			(response)=>{
				if(response){
			let price=getCurrencySymbol(response.data.response.data.currency)+""+response.data.response.data.totalPrice
				setProducts(response.data.response.data.products)
				setResponse(response.data.response.data)
				getTotalItem(response.data.response.data.totalItem,price)
				}
				
			})
		}
	})
	return (
		 <CartContainer>
		
			{products && products.map((item)=>{
				return(
					<div>
						<img src={item.imageUrl}/>
						
						<div>

						<div className='ff-chatbot-caption' style={{ textTransform: 'uppercase',color:'#000',marginBottom:'5px' }}>
                            {item.title}
						 </div>
						 {item.variants[0] && item.variants[0].options.length>0 &&
						    <div className='ff-chatbot-timestamp' style={{ textTransform: 'uppercase' }}>
                             {item.variants[0].options && item.variants[0].options[0].type} : {item.variants[0].options && item.variants[0].options[0].value}
						 </div>

						 }
						 <div className='ff-chatbot-timestamp' style={{ textTransform: 'uppercase' }}>
                            Quantity : {item.cartItems}
						 </div>
						 <div className='ff-chatbot-timestamp' style={{ textTransform: 'uppercase' }}>
						 {getCurrencySymbol(item.variants[0].currency)}  {item.variants[0].price}
						 </div>

						</div>
					</div>

				)
			})

			}

		 </CartContainer>
	);
};

export default MonacoCartItem;
